/**
 * カートページの「ご利用目的」アンケート
 *
 * 選択内容はカートの attributes に保存する（注文の「追加の詳細」と
 * 注文確認メールに載る）。購入手続きボタンでの送信時にも form="cart" で
 * 送られるが、再読み込みで選択が消えないよう、選んだ時点でも保存しておく。
 *
 * 「その他」を選んだときだけ自由記入欄を出し、必須設定なら記入も必須にする。
 */
class CartPurpose extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-purpose-select]');
    this.otherField = this.querySelector('[data-purpose-other]');
    this.otherInput = this.otherField?.querySelector('input');
    if (!this.select) return;

    this.otherValue = this.dataset.otherValue;
    this.attributeName = this.dataset.attribute;
    this.otherAttributeName = this.dataset.otherAttribute;

    this.toggleOther();
    this.select.addEventListener('change', () => {
      this.toggleOther();
      this.save();
    });
    this.otherInput?.addEventListener('input', debounce(() => this.save(), 400));
  }

  get isOther() {
    return this.otherValue && this.select.value === this.otherValue;
  }

  toggleOther() {
    if (!this.otherField) return;
    this.otherField.hidden = !this.isOther;
    this.otherInput.required = this.isOther && this.select.required;
    // 「その他」以外では自由記入を送らない（前に入力した内容が残らないように）
    this.otherInput.disabled = !this.isOther;
  }

  save() {
    const attributes = { [this.attributeName]: this.select.value };
    if (this.otherAttributeName) {
      attributes[this.otherAttributeName] = this.isOther ? this.otherInput.value : '';
    }
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body: JSON.stringify({ attributes }) }).catch(
      () => {
        // 保存に失敗しても、購入手続きボタンの送信時に form="cart" で送られるので致命的ではない
      }
    );
  }
}

if (!customElements.get('cart-purpose')) {
  customElements.define('cart-purpose', CartPurpose);
}
